import { useEffect } from 'react';
import { useActiveRevision } from '@pm2/course-revisions';
import { pm2SitemapStore, findCourseDescriptorFromParents, findPageDescriptorByPath } from '@pm2/sitemap-utils';
import { useLocation } from '@provider/navigation';
import { useTrackingManager } from '@provider/tracking';

function useTrackActiveRevision() {
  const tracker = useTrackingManager();
  const location = useLocation();
  const sitemapStore = pm2SitemapStore.useStore();
  const sitemap = sitemapStore.useSelector(state => state);
  const courseDescriptor = findCourseDescriptorFromParents(sitemap, findPageDescriptorByPath(sitemap, location.asPath));
  const activeRevision = useActiveRevision(courseDescriptor?.id);
  useEffect(() => {
    if (!courseDescriptor || !activeRevision) {
      return;
    }
    tracker.trackEvent("userarea-delinger.revisions.visited", {
      courseTitle: courseDescriptor.title
    });
  }, [activeRevision, courseDescriptor, tracker]);
}

export { useTrackActiveRevision };
//# sourceMappingURL=hook.track-revision.js.map
